import request from ".";

export const scholarshipsApi = {
  getScholarships: () => request.post(`ScholarShips/getAllScholarShipsActive`),
};
